import React from 'react';
import styled from 'styled-components';
import { withQuery } from '@panel/commons/core/themev2';

const SubWrapper = styled.div`
  padding: 40px 40px 45px;
  white-space: normal;
  ${withQuery.lg.down()} {
    padding: 40px 20px 45px;
  }
  ${withQuery.md.down()} {
    padding: 0px 0px 30px;
    margin: 0px 16px;
  }
`;

const ModuleTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  padding: 0px 0px 30px;
  word-wrap: break-word;
  ${withQuery.md.down()} {
    width: auto;
  }
  ${withQuery.xs.down()} {
    font-weight: 400;
    font-size: 18px;
    padding: 28px 0px;
    white-space: inherit;
  }
`;

function ModuleWrapper({ children, title = '' }) {
  return (
    <SubWrapper>
      <ModuleTitle data-repa={`wrapper-title-${title}`}>{title}</ModuleTitle>
      {children}
    </SubWrapper>
  );
}

export { ModuleWrapper };
